module.exports = __webpack_public_path__ + "img/img_service_bg.7e154fdf.jpg";